package net.bothosting.docs.pages.faqs_and_info

import androidx.compose.runtime.*
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.data.*
import com.varabyte.kobweb.core.layout.Layout
import com.varabyte.kobweb.core.layout.NoLayout
import com.varabyte.kobweb.core.init.InitRoute
import com.varabyte.kobweb.core.init.InitRouteContext
import com.varabyte.kobwebx.frontmatter.*
import com.varabyte.kobwebx.markdown.*

@InitRoute
fun initPayment_guidePage(ctx: InitRouteContext) {
    ctx.data.add(MarkdownContext("faqs_and_info/payment_guide.md", FrontMatterElement.Builder { addScalar("description", "Official ways to buy coins"); }))
}

@Page("/faqs_and_info/payment-guide")
@Layout(".components.layouts.DocsLayout")
@Composable
fun Payment_guidePage() {
    org.jetbrains.compose.web.dom.H1(attrs = { id("payment-guide") }) {
        org.jetbrains.compose.web.dom.Text("Payment Guide")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("You can buy coins using these official payment methods:")
    }
    org.jetbrains.compose.web.dom.Ul {
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Code {
                org.jetbrains.compose.web.dom.Text("Credit/Debit Card (Stripe):")
            }
            org.jetbrains.compose.web.dom.Text(" Buy the coins on our website, then complete the payment through the Stripe checkout link.")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Code {
                org.jetbrains.compose.web.dom.Text("PayPal:")
            }
            org.jetbrains.compose.web.dom.Text(" ")
            com.varabyte.kobweb.silk.components.navigation.Link("https://discord.com/channels/884145104401608735/938440875212685442") {
                org.jetbrains.compose.web.dom.Text("Open a ticket in the Discord Support Server")
            }
            org.jetbrains.compose.web.dom.Text(", select ")
            org.jetbrains.compose.web.dom.Code {
                org.jetbrains.compose.web.dom.Text("PAYMENT")
            }
            org.jetbrains.compose.web.dom.Text(", then ")
            org.jetbrains.compose.web.dom.Code {
                org.jetbrains.compose.web.dom.Text("PayPal")
            }
            org.jetbrains.compose.web.dom.Text(", and choose or enter the amount. ")
            org.jetbrains.compose.web.dom.B {
                org.jetbrains.compose.web.dom.Text("Minimum: ${'$'}5")
            }
            org.jetbrains.compose.web.dom.Text(".")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Code {
                org.jetbrains.compose.web.dom.Text("Crypto:")
            }
            org.jetbrains.compose.web.dom.Text(" ")
            com.varabyte.kobweb.silk.components.navigation.Link("https://discord.com/channels/884145104401608735/938440875212685442") {
                org.jetbrains.compose.web.dom.Text("Open a ticket in the Discord Support Server")
            }
            org.jetbrains.compose.web.dom.Text(", select ")
            org.jetbrains.compose.web.dom.Code {
                org.jetbrains.compose.web.dom.Text("PAYMENT")
            }
            org.jetbrains.compose.web.dom.Text(", then ")
            org.jetbrains.compose.web.dom.Code {
                org.jetbrains.compose.web.dom.Text("Crypto")
            }
            org.jetbrains.compose.web.dom.Text(", and choose or enter the amount. ")
            org.jetbrains.compose.web.dom.B {
                org.jetbrains.compose.web.dom.Text("Supported currencies:")
            }
            org.jetbrains.compose.web.dom.Text(" Litecoin (")
            org.jetbrains.compose.web.dom.Code {
                org.jetbrains.compose.web.dom.Text("LTC")
            }
            org.jetbrains.compose.web.dom.Text(") and Bitcoin (")
            org.jetbrains.compose.web.dom.Code {
                org.jetbrains.compose.web.dom.Text("BTC")
            }
            org.jetbrains.compose.web.dom.Text(").")
        }
    }
    org.jetbrains.compose.web.dom.H3(attrs = { id("notes") }) {
        org.jetbrains.compose.web.dom.Text("Notes")
    }
    org.jetbrains.compose.web.dom.Ul {
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("If someone else is paying for you on the website, send them the Stripe checkout link.")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("If you are paying for someone else with PayPal or crypto, include the Discord user ID of the person who should receive the coins when you open the ticket.")
        }
    }
    com.varabyte.kobweb.silk.components.display.Callout(type = com.varabyte.kobweb.silk.components.display.CalloutType.TIP, label = null, variant = com.varabyte.kobweb.silk.components.display.CalloutDefaults.Variant) {
        org.jetbrains.compose.web.dom.P {
            org.jetbrains.compose.web.dom.Text(" You can check the benefits of the pack you are buying directly on the bot-hosting website ")
            com.varabyte.kobweb.silk.components.navigation.Link("https://bot-hosting.net/panel/earn") {
                org.jetbrains.compose.web.dom.Text("here")
            }
            org.jetbrains.compose.web.dom.Text(".")
        }
    }
}
